import Cookies from 'js-cookie'
import { getSystemRole, getTheme, setTheme, setLastProjectId, setLanguage, getUserInfo, getLanguage, getFactorInfo, setFactorInfo, setDomainList, getDomainList, getCurrentDomain, setLastProject, getLastProject, setCurrentDomain } from '@/utils/auth.js'
import store from "@/store";
let userInfo = getUserInfo()
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: getLanguage(),
    projectInfo: getLastProject(userInfo.id),
    projectList: [],
    lastAlertPoint: null,
    pageConfig: null,
    warningNum: 0,
    weather: null,
    theme: getTheme() || 'light-theme',
    factorInfo: getFactorInfo() || {},
    domainList: getDomainList(),
    currentDomain: getCurrentDomain(),
    isCheckDialog: false,
    isSystemRole: getSystemRole()
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      setLanguage(language)
    },
    SET_PROJECTINFO: (state, projectInfo) => {
      if (Object.keys(projectInfo).length) {
        state.projectInfo = projectInfo;
        setLastProjectId(store.state.user.userInfo.id, projectInfo.id)
        // 用作历史projectInfo获取，实际使用的项目信息已在此处覆盖
        setLastProject(store.state.user.userInfo.id, projectInfo)
      }
    },
    SET_LASTALERTPOINT: (state, alert) => {
      state.lastAlertPoint = alert
    },
    SET_PAGECONFIG: (state, config) => {
      state.pageConfig = config
    },
    SET_WARNINGNUM: (state, config) => {
      state.warningNum = config
    },
    SET_THEME: (state, config) => {
      state.theme = config
      setTheme(config)
    },
    SET_WEATHER: (state, config) => {
      state.weather = config
    },
    SET_FACTORINFO: (state, config) => {
      state.factorInfo = config
      setFactorInfo(config)
    },
    SET_DOMAINLIST: (state, config) => {
      state.domainList = config
      setDomainList(config)
    },
    SET_CURRENTDOMAIN: (state, config) => {
      state.currentDomain = config
      setCurrentDomain(config)
    },
    SET_CHECKDIALOG: (state, config) => {
      state.isCheckDialog = config
    },
    SET_SYSTEMROLE: (state, config) => {
      state.isSystemRole = config
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setLastAlertPoint({ commit }, alert) {
      commit('SET_LASTALERTPOINT', alert)
    },
    setProjectId({ commit }, projectInfo) {
      commit('SET_PROJECTINFO', projectInfo)
    },
    setPageConfig({ commit }, config) {
      commit('SET_PAGECONFIG', config)
    },
    setWarningNum({ commit }, config) {
      commit('SET_WARNINGNUM', config)
    },
    setThemeStore({ commit }, config) {
      commit('SET_THEME', config)
    },
    setWeather({ commit }, config) {
      commit('SET_WEATHER', config)
    },
    setFactorInfo({ commit }, config) {
      commit('SET_FACTORINFO', config)
    }
  }
}

export default app
